import styled from 'styled-components'
import { mediaQueryOnly, mediaQueryUp } from 'components/utils/breakpoint'
import AccommodationRoomTileImage from '../AccommodationRoomTileImage'

const AccommodationSameRoomTileImage = styled(AccommodationRoomTileImage)`
  ${mediaQueryUp.tablet} {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }

  ${mediaQueryOnly.tablet} {
    border-bottom: 0;
  }

  ${mediaQueryUp.desktop} {
    border-right: 0;
  }
`

export default AccommodationSameRoomTileImage
